import { render, staticRenderFns } from "./StOpenTag.vue?vue&type=template&id=afd5a9d6&"
import script from "./StOpenTag.vue?vue&type=script&lang=js&"
export * from "./StOpenTag.vue?vue&type=script&lang=js&"
import style0 from "./StOpenTag.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports